import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: `${i18n.t('Device.shadowName')}/${i18n.t('Device.identifier')} `,
    filed: 'code',
    default: ''
  }
]
